<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">化学品领用申请</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="申请单号">
          <el-input v-model="formInline.apply_no" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="申请人姓名">
          <el-input v-model="formInline.username" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="化学品名称">
          <el-input v-model="formInline.chemical_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择">
            <el-option v-for="item in $store.state.reviewStatus2" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请日期">
          <el-date-picker v-model="formInline.date" type="daterange" range-separator="至" value-format="yyyy-MM-dd"
            clearable start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd(() => {
            getChemicals()
          })">新增申请</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训化学品采购申请模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="action" :params="params"
            :btnTitle="btnTitle"></Importt>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column fixed prop="apply_no" label="申请单号" width="150">
        </custom-table-column>
        <custom-table-column fixed prop="chemical_name" label="化学品" min-width="150">
        </custom-table-column>
        <custom-table-column prop="quantity" label="领用数量" width="80">
        </custom-table-column>
        <custom-table-column prop="unit" label="单位" width="80">
        </custom-table-column>
        <custom-table-column prop="status_text" label="状态" width="80">
        </custom-table-column>
        <custom-table-column prop="apply_structure_1" label="所属院系" width="180">
        </custom-table-column>
        <custom-table-column prop="apply_structure_2" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="purpose" label="申请理由" min-width="200px">
        </custom-table-column>
        <custom-table-column prop="review_name" label="审批人" width="100px">
        </custom-table-column>
        <custom-table-column prop="review_desc" label="说明原因" width="160px">
        </custom-table-column>
        <custom-table-column prop="review_time" label="审批时间" width="160px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="detailMethod(scope.row, 'view')" type="text" size="small">详情</el-button>
            <el-button @click="detailMethod(scope.row, 'edit')" v-if="scope.row.status == 1" type="text"
              size="small">编辑</el-button>
            <el-button v-if="scope.row.status != 2" @click="handleDelet(scope.row.id)" type="text"
              size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="756px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery">
      </OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="组织结构" prop="apply_structure_2">
          <el-input v-model="selectName" placeholder="请选择" style="width:562px;" @focus="dialogOpen"
            @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`所属${$store.state.themeTitle}室`" prop="apply_training_room_id">
          <el-select v-model="ruleForm.apply_training_room_id" clearable filterable :placeholder="`请选择`"
            @change="handleTargetChange" style="width: 216px;">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="化学品" prop="chemical_id">
          <el-select v-model="ruleForm.chemical_id" clearable filterable :placeholder="`请选择`" style="width: 216px;"
            @change="handleChemicalChange">
            <el-option v-for="item in chemicals" :key="item.id" :label="item.name" :value="item.id"
              :disabled="item.current_stock * 1 == 0">
              <p>{{ item.name }}</p>
              <p v-if="item.current_stock" class="el-option-tips">当前库存：{{ item.current_stock }}</p>
              <p v-if="item.category" class="el-option-tips">分类：{{ item.category }}</p>
              <p v-if="item.unit" class="el-option-tips">单位：{{ item.unit }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="领用数量" prop="quantity">
          <el-input v-model="ruleForm.quantity" clearable placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="申请理由" prop="purpose">
          <el-input type="textarea" v-model="ruleForm.purpose" placeholder="请输入" style="width:562px;" :rows="4">
          </el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="采购详情" :visible.sync="detailDialogVisible" width="746px">
      <el-descriptions class="margin-top" title="申请单" direction="vertical" :column="3" border v-if="rowObj">
        <!-- <el-descriptions-item>
          <template slot="label">采购类别 </template> {{ rowObj.type }}
        </el-descriptions-item> -->
        <el-descriptions-item>
          <template slot="label">申请单号 </template> {{ rowObj.apply_no }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">化学品 </template> {{ rowObj.chemical_name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">领用数量 </template> {{ rowObj.quantity }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">单位 </template> {{ rowObj.unit }}
        </el-descriptions-item>
        <el-descriptions-item :span="2">
          <template slot="label">申请理由 </template> {{ rowObj.purpose }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">所属院系 </template> {{ rowObj.apply_structure_1 }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">专业 </template> {{ rowObj.apply_structure_2 }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">所属{{ $store.state.themeTitle }}室 </template> {{ rowObj.apply_training_room_name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">状态 </template> {{ rowObj.status_text }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">说明原因 </template> {{ rowObj.review_desc }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">审批时间 </template> {{ rowObj.review_time }}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinImport, mixinValidate, mixinFormatter],
  data() {
    return {
      formInline: {
        apply_no: '',
        username: '',
        chemical_name: '',
        status: '',
        start_date: '',
        end_date: '',
        date: '',
      },
      chemicals: [],
      size: 'small',
      detailDialogVisible: false,
      levell: [1, 2],
      selectName: '',
      organLabel: '',
      ruleForm: {
        "apply_structure_1": "",
        "apply_structure_2": "",
        "apply_training_room_id": "",
        "apply_training_room_name": "",
        "apply_training_room_number": '',
        "chemical_id": "",
        "quantity": "",
        "unit": "",
        "purpose": "",
      },
      rowObj: {},
      rules: {
        apply_training_room_id: [{ required: true, message: '请选择', trigger: 'change' }],
        apply_structure_2: [{ required: true, message: '请选择院系专业' }],
        chemical_id: [{ required: true, message: '请选择', trigger: 'change' }],
        quantity: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' },
        ],
        purpose: [{ required: true, message: '请输入', trigger: 'blur' }],
        // training_room: [{ required: true, message: `请输入所属${this.$store.state.themeTitle}室`, trigger: 'change' }],
      },
      action: '',
      downloadUrl: '',
      downloadName: '实训化学品采购申请模版.xlsx',
      btnTitle: '导入实训化学品采购申请数据',
      listArr: [],
    };
  },
  created() {
    this.action = `${this.baseUrlt}api/device/purchase2/import`;
    this.downloadUrl = `api/device/purchase2/getTemplate`;
    this.$store.dispatch('getTarinMent');

    // this.$store.dispatch('getTermms');
  },
  computed: {
  },
  mounted() { },
  methods: {
    handleTargetChange(val) {
      const { training_name, training_no } = this.$until.getLabelNameNew({ arr: this.$store.state.trainRooms, id: val })
      this.ruleForm.apply_training_room_name = training_name;
      this.ruleForm.apply_training_room_number = training_no;
    },
    handleChemicalChange(val) {
      const { unit } = this.$until.getLabelNameNew({ arr: this.chemicals, id: val })
      this.ruleForm.unit = unit;
    },
    // async detailMethod(row, type = "view") {
    //   let res = await this.$api.instance.interfaceServer(`api/chemical/purchase/detail/${row.id}`, 'get');
    //   if (res.code == 0 && res.data) {
    //     if (type == "view") {
    //       this.rowObj = res.data;
    //       this.detailDialogVisible = true;
    //     } else {
    //       this.handleEditNew(res.data)
    //     }
    //   }
    // },
    detailMethod(row, type = "view") {
      if (type == "view") {
        this.rowObj = row;
        this.detailDialogVisible = true;
      } else {
        this.handleEditNew(row, ['id'], () => {
          this.handleEditCallBackSetStruc({ major: 'apply_structure_2', dep: 'apply_structure_1', row: row })
        })
      }
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/chemical/borrow/delete/${params.id}`, 'DELETE', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/chemical/borrow/create', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/chemical/borrow/update/${params.id}`, 'put', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    getOrganList() {
      this.beforeGetOrgan({ limit: false, major: "apply_structure_2", dep: 'apply_structure_1' });
      // this.$store.dispatch('getTarinMent', { structure_1: this.ruleForm.apply_structure_1, structure_2: this.ruleForm.apply_structure_2});

    },
    handleQuery() {
      this.beforeQueryByKeyNew({ major: "apply_structure_2", dep: 'apply_structure_1' });
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getChemicals() {
      let res = await this.$api.instance.interfaceServer('api/chemical/info/list', 'get', { page: 1, size: 9999 });
      if (res.code == 0 && res.data) {
        this.chemicals = res.data.data;
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      if (params.date && params.date.length > 0) {
        params.start_date = params.date[0];
        params.end_date = params.date[1];
        delete params.date;
      }
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/chemical/borrow/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
